
export const SET_APP_THEME: string = "SET_APP_THEME";
export const SET_SHOW_POPUP: string = "SET_SHOW_POPUP";
export const SET_MODAL_CHILDREN: string = "SET_MODAL_CHILDREN";